import { Button, Col, Form, Row } from "react-bootstrap";
import AirportDeparture from "./AirportDeparture ";
import AirportDestination from "./AirportDestination ";
import Carrier from "./Carrier";
import TimeArrival from "./TimeArrival";
import TimeDeparture from "./TimeDeparture";

import { MdDelete } from "react-icons/md";
import DateArrival from "./DateArrival";
import DateDept from "./DateDept";
import { RenderDateInput } from "app/common/renderInput";

const FlightLegs = ({
  index,
  values,
  touched,
  errors,
  handleChange,

  tripType,
  arrayHelpers,
  setFieldValue,
  array,
}) => {
  return (
    <>
      {index > 0 && <hr />}
      <Row
        style={{
          //  backgroundColor: "#e4ffff"  ,
          marginBottom: 8,
        }}
      >
        {index != 0 && (
          <Col>
            <div style={{ fontSize: 15, fontWeight: "bold" }}>
              Stops -{index}
            </div>
          </Col>
        )}
        {/* disabled={index == array.length - 1 ? false : true} */}
        {index > 0 && (
          <Col xs="6">
            {index == array.length - 1 && (
              <div className="d-flex justify-content-end ">
                <Button
                  variant="danger"
                  type="button"
                  onClick={() => {
                    arrayHelpers.remove(index);
                  }}
                >
                  <MdDelete color="white" size={20} />
                </Button>
              </div>
            )}
          </Col>
        )}
      </Row>
      <Row>
        <Col xs="12" md="6" lg={tripType == 2 || tripType == 3 ? "6" : "3"}>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label>
              Airlines <span className="text-danger">*</span>
            </Form.Label>

            <Carrier index={index} setFieldValue={setFieldValue} />

            {touched?.flightLegs?.return &&
            errors?.flightLegs?.return &&
            touched?.flightLegs?.return[index]?.airline &&
            errors?.flightLegs?.return[index]?.airline ? (
              <div
                type="invalid"
                style={{
                  fontSize: "10px",
                  color: "red",
                }}
              >
                {errors?.flightLegs?.return[index]?.airline}{" "}
              </div>
            ) : (
              ""
            )}
          </Form.Group>
        </Col>
        <Col xs="12" md="6" lg={tripType == 2 || tripType == 3 ? "6" : "3"}>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label>
              Flight Number <span className="text-danger">*</span>
            </Form.Label>
            <input
              type="text"
              className="form-control"
              placeholder="Flight Number"
              name={`flightLegs.return[${index}].fN`}
              value={values?.flightLegs?.return[index]?.fN || ""}
              onChange={handleChange}
            />
            {touched?.flightLegs?.return &&
            errors?.flightLegs?.return &&
            touched.flightLegs?.return[index]?.fN &&
            errors?.flightLegs?.return[index]?.fN ? (
              <div
                type="invalid"
                style={{
                  fontSize: "10px",
                  color: "red",
                }}
              >
                {errors?.flightLegs?.return[index]?.fN}{" "}
              </div>
            ) : (
              ""
            )}
          </Form.Group>
        </Col>
        <Col xs="12" md="6" lg={tripType == 2 || tripType == 3 ? "6" : "3"}>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label>
              PNR <span className="text-danger">*</span>
            </Form.Label>
            <input
              type="text"
              className="form-control"
              placeholder="PNR"
              name={`flightLegs.return[${index}].pnr`}
              value={values?.flightLegs?.return[index]?.pnr || ""}
              onChange={handleChange}
            />
            {touched?.flightLegs?.return &&
            errors?.flightLegs?.return &&
            touched?.flightLegs?.return[index]?.pnr &&
            errors?.flightLegs?.return[index]?.pnr ? (
              <div
                type="invalid"
                style={{
                  fontSize: "10px",
                  color: "red",
                }}
              >
                {errors?.flightLegs?.return[index]?.pnr}{" "}
              </div>
            ) : (
              ""
            )}
          </Form.Group>
        </Col>
        <Col xs="12" md="6" lg={tripType == 2 || tripType == 3 ? "6" : "3"}>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label>GDS PNR</Form.Label>

            <input
              className="form-control"
              type="text"
              placeholder="GDS PNR"
              name={`flightLegs.return[${index}].gdsPnr`}
              value={values.flightLegs.return[index].gdsPnr || ""}
              onChange={handleChange}
            />
            {touched?.flightLegs?.return &&
            errors?.flightLegs?.return &&
            touched?.flightLegs?.return[index]?.gdsPnr &&
            errors?.flightLegs?.return[index]?.gdsPnr ? (
              <div
                type="invalid"
                style={{
                  fontSize: "10px",
                  color: "red",
                }}
              >
                {errors?.flightLegs?.return[index]?.gdsPnr}{" "}
              </div>
            ) : (
              ""
            )}
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col xs="12" md="6" lg={tripType == 2 || tripType == 3 ? "6" : "3"}>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label>
              Departure Airport <span className="text-danger">*</span>
            </Form.Label>

            <AirportDeparture index={index} setFieldValue={setFieldValue} />

            {touched?.flightLegs?.return &&
            errors?.flightLegs?.return &&
            touched.flightLegs?.return[index]?.airportDepartureId &&
            errors?.flightLegs?.return[index]?.airportDepartureId ? (
              <div
                type="invalid"
                style={{
                  fontSize: "10px",
                  color: "red",
                }}
              >
                {errors?.flightLegs?.return[index]?.airportDepartureId}
              </div>
            ) : (
              ""
            )}
          </Form.Group>
        </Col>
        <Col xs="12" md="6" lg={tripType == 2 || tripType == 3 ? "6" : "3"}>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label>
              Arrival Airport <span className="text-danger">*</span>
            </Form.Label>

            <AirportDestination index={index} setFieldValue={setFieldValue} />

            {touched?.flightLegs?.return &&
            touched.flightLegs.return[index]?.airportDestinationId &&
            errors?.flightLegs?.return &&
            errors.flightLegs.return[index]?.airportDestinationId ? (
              <div
                type="invalid"
                style={{
                  fontSize: "10px",
                  color: "red",
                }}
              >
                {errors?.flightLegs?.return[index]?.airportDestinationId}
              </div>
            ) : (
              ""
            )}
          </Form.Group>
        </Col>
        <Col xs="12" md="6" lg={tripType == 2 || tripType == 3 ? "6" : "3"}>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label>
              Departure Date <span className="text-danger">*</span>{" "}
            </Form.Label>
            <div style={{ marginTop: -20, marginBottom: -10 }}>
              <RenderDateInput
                type="date"
                name={`flightLegs.return[${index}].departureDate`}
                value={values?.flightLegs?.return[index]?.departureDate || ""}
                onChange={handleChange}
              ></RenderDateInput>
            </div>
            {touched?.flightLegs?.return &&
            touched.flightLegs.return[index]?.departureDate &&
            errors?.flightLegs?.return &&
            errors.flightLegs.return[index]?.departureDate ? (
              <div
                type="invalid"
                style={{
                  fontSize: "10px",
                  color: "red",
                }}
              >
                {errors?.flightLegs?.return[index]?.departureDate}
              </div>
            ) : (
              ""
            )}
          </Form.Group>
        </Col>
        <Col xs="12" md="6" lg={tripType == 2 || tripType == 3 ? "6" : "3"}>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label>
              Arrival Date<span className="text-danger">*</span>
            </Form.Label>
            <div style={{ marginTop: -20, marginBottom: -10 }}>
              <RenderDateInput
                type="date"
                name={`flightLegs.return[${index}].arrivalDate`}
                value={values?.flightLegs?.return[index]?.arrivalDate || ""}
                onChange={handleChange}
              ></RenderDateInput>
            </div>
            {touched?.flightLegs?.return &&
            touched.flightLegs.return[index]?.arrivalDate &&
            errors?.flightLegs?.return &&
            errors.flightLegs.return[index]?.arrivalDate ? (
              <div
                type="invalid"
                style={{
                  fontSize: "10px",
                  color: "red",
                }}
              >
                {errors?.flightLegs?.return[index]?.arrivalDate}
              </div>
            ) : (
              ""
            )}
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col xs="12" md="6" lg={tripType == 2 || tripType == 3 ? "6" : "3"}>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label>
              Departure Time <span className="text-danger">*</span>
            </Form.Label>
            <TimeDeparture
              index={index}
              values={values}
              handleChange={handleChange}
            />
            {touched?.flightLegs?.return &&
            errors?.flightLegs?.return &&
            touched?.flightLegs?.return[index]?.departureTime &&
            errors?.flightLegs?.return[index]?.departureTime ? (
              <div
                type="invalid"
                style={{
                  fontSize: "10px",
                  color: "red",
                }}
              >
                {errors?.flightLegs?.return[index]?.departureTime}
              </div>
            ) : (
              ""
            )}
          </Form.Group>
        </Col>
        <Col xs="12" md="6" lg={tripType == 2 || tripType == 3 ? "6" : "3"}>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label>
              Arrival Time <span className="text-danger">*</span>
            </Form.Label>
            <TimeArrival
              index={index}
              values={values}
              handleChange={handleChange}
            />
            {touched?.flightLegs?.return &&
            errors?.flightLegs?.return &&
            touched?.flightLegs?.return[index]?.arrivalTime &&
            errors?.flightLegs?.return[index]?.arrivalTime ? (
              <div
                type="invalid"
                style={{
                  fontSize: "10px",
                  color: "red",
                }}
              >
                {errors?.flightLegs?.return[index]?.arrivalTime}
              </div>
            ) : (
              ""
            )}
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col xs="12" md="6" lg={tripType == 2 || tripType == 3 ? "6" : "6"}>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label>Departure Terminal</Form.Label>
            <input
              type="text"
              className="form-control"
              placeholder="Departure Terminal"
              name={`flightLegs.return[${index}].airportDepartureTerminal`}
              value={
                values?.flightLegs?.return[index]?.airportDepartureTerminal ||
                ""
              }
              onChange={handleChange}
            />
            {touched?.flightLegs?.return &&
            errors?.flightLegs?.return &&
            touched.flightLegs?.return[index]?.airportDepartureTerminal &&
            errors?.flightLegs?.return[index]?.airportDepartureTerminal ? (
              <div
                type="invalid"
                style={{
                  fontSize: "10px",
                  color: "red",
                }}
              >
                {
                  errors?.flightLegs?.return[index]?.airportDepartureTerminal
                }{" "}
              </div>
            ) : (
              ""
            )}
          </Form.Group>
        </Col>
        <Col xs="12" md="6" lg={tripType == 2 || tripType == 3 ? "6" : "6"}>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label>Arrival Terminal</Form.Label>
            <input
              type="text"
              className="form-control"
              placeholder="Arrival Terminal"
              name={`flightLegs.return[${index}].airportDestinationTerminal`}
              value={
                values?.flightLegs?.return[index]?.airportDestinationTerminal ||
                ""
              }
              onChange={handleChange}
            />
            {touched?.flightLegs?.return &&
            errors?.flightLegs?.return &&
            touched?.flightLegs?.return[index]?.airportDestinationTerminal &&
            errors?.flightLegs?.return[index]?.airportDestinationTerminal ? (
              <div
                type="invalid"
                style={{
                  fontSize: "10px",
                  color: "red",
                }}
              >
                {
                  errors?.flightLegs?.return[index]?.airportDestinationTerminal
                }{" "}
              </div>
            ) : (
              ""
            )}
          </Form.Group>
        </Col>
      </Row>
    </>
  );
};

export default FlightLegs;
